module.exports = __webpack_public_path__ + "static/media/news.0c0d2c17.png";